import type { LayoutBand, SlotKind } from '@/api/types';

export const BAND_LABEL: Record<LayoutBand, string> = {
  default: 'Default',
  ages_2_4: 'Ages 2–4',
  ages_5_7: 'Ages 5–7',
  ages_8_10: 'Ages 8–10',
};

export const SLOT_LABEL: Record<SlotKind, { label: string; help: string }> = {
  hero: { label: 'Hero', help: 'The big feature. Uses a hero collection.' },
  continue: { label: 'Continue watching', help: 'Filled by the app from the child’s history.' },
  selected: { label: 'Chosen by your grown-up', help: 'The parent-curated collection.' },
  because_you_like: { label: 'Because you like…', help: 'One row per strong interest.' },
  overlap: {
    label: 'Interest × objective',
    help: 'Programmes that match a liked interest and strongly support a grown-up’s objective.',
  },
  surprise: { label: 'Surprise yourself', help: 'Discovery picks.' },
  favourites: { label: 'Favourites', help: 'The child’s favourites.' },
  collection: { label: 'Editorial collection', help: 'A collection you choose.' },
  recent: { label: 'Recently added', help: 'Newest published programmes.' },
};
